import React from 'react';

import { useField } from 'formik';

import * as S from './styles';

const DEFAULT_MIN = 1;

interface IGradeInputProps {
  name: string;
  min?: number;
  max: number;
}

const GradeInput: React.FC<IGradeInputProps> = ({
  name,
  max,
  min = DEFAULT_MIN,
}) => {
  const [field, , helpers] = useField<number>(name);

  return (
    <S.Container>
      {Array.from({ length: max - min + 1 }, (_, index) => {
        const value = index + min;

        return (
          <S.SelectionButton
            type="button"
            data-selected={field.value >= value}
            key={value}
            onClick={() => {
              helpers.setTouched(true);
              helpers.setValue(value);
            }}
          >
            {value}
          </S.SelectionButton>
        );
      })}
    </S.Container>
  );
};

export default GradeInput;
